import { Box } from "@chakra-ui/react";
import DesktopNavbar from "./DesktopNavbar/DesktopNavbar";
import MobileNavbar from "./MobileNavbar/MobileNavbar";
import { setCartProductRReducer } from "../../Redux/action";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

const Navbar = () => {
  const mobileView = useSelector((state) => state.mobileView);

  return (
    <Box >
      {mobileView ? (
        <MobileNavbar />
      ) : (
        <DesktopNavbar />
      )}
    </Box>
  );
};

export default Navbar;
